import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Form, Image, Row } from 'react-bootstrap';
import camera from '../../Assets/Img/camera.png';
import '../Profile/profile.scss';
import { CircleUserRound } from 'lucide-react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import config from '../../Api/config';
import { formatDate } from '../../helper';

const PosProfile = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    console.log(state, 'statestate');
    const [profileData, setProfileData] = useState({
        ...state?.userData,
        dateOfBirth: formatDate(state?.userData?.dateOfBirth),
    });
    return (
        <>
            <Container fluid className={`custom_disabled`}>
                <div className="profile_header">
                    <Card className="mb-4">
                        <Card.Body className="modal_form">
                            {/* <h5 className="fw-semibold mb-4">
                                {t('nameAndPicTitle')}
                            </h5> */}
                            {/* <div className='profile_image mb-4' >

                                {profileData?.profileImagePath !== "" ? <Image src={`${config.img_URL}/${profileData?.profileImagePath}`} /> : <CircleUserRound width={120} height={120} />}
                                <div role='button' className='image_upload_button'>
                                    <Form.Control type="file" />
                                    <img
                                        src={camera}
                                        style={{
                                            height: '24px',
                                            width: '24px',
                                        }}
                                    />
                                </div>
                            </div> */}
                            <Row className="">
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{'N° PDV'}</Form.Label>
                                        <Form.Control
                                            value={profileData?.infoUserId}
                                            type="text"
                                            name="name"
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('name')}</Form.Label>
                                        <Form.Control
                                            value={profileData?.name}
                                            type="text"
                                            name="name"
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('email')}</Form.Label>
                                        <Form.Control
                                            value={profileData?.email}
                                            type="email"
                                            name="email"
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
                <div className="profile_details">
                    <Card className="mb-4">
                        <Card.Body className="modal_form">
                            <h5 className="fw-semibold mb-4">
                                {t('personalInformation')}
                            </h5>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>{t('userType')}</Form.Label>
                                        <Form.Select
                                            aria-label="Default"
                                            name="userType"
                                            required
                                            readOnly
                                        >
                                            <option value="">
                                                {profileData?.userType}
                                            </option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {/* <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('dateofBirth')}
                                        </Form.Label>
                                        <Form.Control
                                            value={profileData?.dateOfBirth}
                                            type="text"
                                            name="dateOfBirth"
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col> */}
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('phone')}</Form.Label>
                                        <Form.Control
                                            value={profileData?.mobile}
                                            type="text"
                                            name="mobile"
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        </>
    );
};

export default PosProfile;
